import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-processing-visual',
  imports: [NgStyle, TranslatePipe],
  templateUrl: './processing-visual.component.html',
  styleUrl: './processing-visual.component.scss',
})
export class ProcessingVisualComponent {
  @Input({ required: true }) percent!: number;
  @Input({ required: true }) elapsedDisplay!: string;
  @Input({ required: true }) durationDisplay!: string;
  @Input() label: string = "demo.dialog.steps.loadingFinal";
}
